﻿import { FormProps } from '@shared/components/Form/Form';
import { type Contact } from './Contact.access';

export const setupInitValues = (contact: Contact, form: FormProps) => {
    for (const [key, value] of Object.entries(form.data)) {
        let value = (contact as any)[key];

        if (value) {
            if (form.data[key].input?.type === 'date') {
                value = new Date(value).toLocaleDateString();
            }

            // also add .toLocaleTimeString()

            form.data[key].modelValue = value;
        }
    }
};
